import type { BetterFetch } from "@better-fetch/fetch";
import { atom } from "nanostores";

// Create query set map for endpoint contracts
export function createQuerySetMap(endpointContract: any, $fetch: BetterFetch) {
	const querySets: Record<string, any> = {};

	for (const [key, endpoint] of Object.entries(endpointContract)) {
		const endpointConfig = endpoint as any;

		querySets[key] = {
			query: createQueryFunction(endpointConfig, $fetch),
			signal: atom(null),
		};
	}

	return querySets;
}

// Create query function for an endpoint
function createQueryFunction(endpoint: any, $fetch: BetterFetch) {
	return async (params?: any) => {
		let path = endpoint.path;
		const method = endpoint.method;
		const requestConfig: any = {
			method,
		};

		// Handle path parameters
		if (params && endpoint.pathSchema && path.includes(":")) {
			for (const [key, value] of Object.entries(params)) {
				path = path.replace(`:${key}`, String(value));
			}
		}

		// Handle query parameters
		if (method === "GET" && params && endpoint.querySchema) {
			const queryParams = new URLSearchParams(params).toString();
			path = queryParams ? `${path}?${queryParams}` : path;
		}

		// Handle request body
		if (method !== "GET" && params && endpoint.requestSchema) {
			requestConfig.body = JSON.stringify(params);
			requestConfig.headers = {
				"Content-Type": "application/json",
			};
		}

		return $fetch(path, requestConfig);
	};
}

// Extract signals from query sets
export function extractSignals(querySets: Record<string, any>) {
	const signals: Record<string, any> = {};

	for (const [key, querySet] of Object.entries(querySets)) {
		signals[`$${key}Signal`] = querySet.signal;
	}

	return signals;
}

// Extract queries from query sets
export function extractQueries(querySets: Record<string, any>) {
	const queries: Record<string, any> = {};

	for (const [key, querySet] of Object.entries(querySets)) {
		queries[key] = querySet.query;
	}

	return queries;
}

// Extract listeners from query sets
export function extractListeners(_querySets: Record<string, any>) {
	return [
		{
			signal: "$sessionSignal",
			matcher: (path: string) => path.startsWith("/auth"),
		},
	];
}
